import React from 'react';

function LoadingSpinner({ size = 'md', message = '' }) {
  const sizeStyles = {
    sm: { width: '24px', height: '24px' },
    md: { width: '40px', height: '40px' },
    lg: { width: '60px', height: '60px' }
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div 
        style={{
          ...sizeStyles[size],
          border: '4px solid #e2e8f0',
          borderTop: '4px solid #4361ee',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: message ? '12px' : '0'
        }}
      />
      {message && (
        <p style={{ 
          color: '#64748b', 
          margin: 0,
          fontSize: '14px'
        }}>
          {message}
        </p>
      )}
    </div>
  );
}

export default LoadingSpinner;